/**
 * Settings API endpoints
 */
import { api } from './baseApi';

export interface Settings {
  id: number;
  platform_fee_percentage: string;
  specialist_commission_percentage: string;
  service_cancellation_hours: number;
  email_host: string;
  email_port: number;
  email_use_tls: boolean;
  email_host_user: string;
  email_host_password: string;
  default_from_email: string;
  otp_length: number;
  otp_expiry_minutes: number;
  include_otp_in_response: boolean;
  fawry_merchant_code: string;
  fawry_security_key: string;
  fawry_api_url: string;
  app_name: string;
  app_version: string;
  support_email: string;
  support_phone: string;
  maintenance_mode: boolean;
  maintenance_message: string;
  created_at: string;
  updated_at: string;
}

export interface SettingsResponse {
  success: boolean;
  data: Settings;
}

export interface UpdateSettingsData {
  platform_fee_percentage?: number;
  specialist_commission_percentage?: number;
  service_cancellation_hours?: number;
  email_host?: string;
  email_port?: number;
  email_use_tls?: boolean;
  email_host_user?: string;
  email_host_password?: string;
  default_from_email?: string;
  otp_length?: number;
  otp_expiry_minutes?: number;
  include_otp_in_response?: boolean;
  fawry_merchant_code?: string;
  fawry_security_key?: string;
  fawry_api_url?: string;
  app_name?: string;
  app_version?: string;
  support_email?: string;
  support_phone?: string;
  maintenance_mode?: boolean;
  maintenance_message?: string;
}

export const settingsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => '/dashboard/settings/',
      providesTags: ['Settings'],
    }),
    updateSettings: builder.mutation<SettingsResponse, UpdateSettingsData>({
      query: (data) => ({
        url: '/dashboard/settings/',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
} = settingsApi;

